/**
 * Bascule « afficher / masquer » des champs mot de passe (#2546).
 *
 * Chargé par `layouts/auth.blade.php`, il sert la création de compte et la
 * réinitialisation : deux formulaires où l'on saisit un mot de passe qu'on ne
 * connaît pas encore par cœur, et où la faute de frappe ne se voit qu'au
 * message d'erreur.
 *
 * Clics délégués au document, comme dans `parent-push.js` : les boutons sont
 * rendus par le serveur à l'intérieur de `#app`, et rien ne garantit qu'ils
 * survivront au montage d'un composant.
 */

function toggle(button) {
    const input = document.getElementById(button.getAttribute('data-password-toggle'));

    if (!input) {
        return;
    }

    const wasVisible = input.type === 'text';

    input.type = wasVisible ? 'password' : 'text';

    const label = button.getAttribute(wasVisible ? 'data-label-show' : 'data-label-hide');

    button.setAttribute('aria-pressed', String(!wasVisible));

    if (label) {
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
    }

    button.querySelectorAll('[data-when]').forEach((icon) => {
        const showsWhenVisible = icon.getAttribute('data-when') === 'shown';

        icon.classList.toggle('d-none', showsWhenVisible === wasVisible);
    });

    if (document.activeElement === button || document.activeElement === input) {
        const end = input.value.length;

        input.focus();

        try {
            input.setSelectionRange(end, end);
        } catch (e) {

        }
    }
}

document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
        return;
    }

    const button = event.target.closest('[data-password-toggle]');

    if (button) {
        event.preventDefault();
        toggle(button);
    }
});
